import { forwardRef, useCallback, useImperativeHandle, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import AWS from "aws-sdk";
import config from "../../../../../../application/config/config";
import { Buffer } from "buffer";
import Toast from "../../Toast/Toast";
import { v4 as uuidv4 } from 'uuid';
import moment from "moment";
import { useKeysStore } from "../../../../../store/useKeysStore";



export const SignatureField = forwardRef((props, ref) => {
  const { keys } = useKeysStore();
  const padRef = useRef(null);
  const containerRef =  useRef(null);
  const [canvas, setCanvas] = useState(props.value || undefined);
  const [isHighlighted, setIsHighlighted] = useState(false);
  const [canvasVisibility, setCanvasVisibility] = useState(canvas ? true : false);

  const highlightSignatureField = () => {
    setIsHighlighted(true);
    setTimeout(() => setIsHighlighted(false), 3000);
  };

  const focusSignatureField = () => {
    containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  useImperativeHandle(ref, () => ({
    clear: () => {
      clearSignatureCanvas();
    },
    focus: () => {
      highlightSignatureField();
      focusSignatureField();
    }
  }));

  AWS.config.update({
    accessKeyId: keys?.bucketS3?.accessKeyId,
    secretAccessKey: keys?.bucketS3?.secretAccessKey,
    region: keys?.bucketS3?.region,
  });



  const clearSignatureCanvas = useCallback((e) => {
    e.preventDefault();
    padRef?.current?.clear();
    setCanvas(undefined);
    setCanvasVisibility(false);
    props.onRemove(props.name);
  }, []);

  const handleGetCanvas = useCallback(async (e) => {
    e.preventDefault();

    const canvas = padRef?.current?.toDataURL();
    const s3 = new AWS.S3();
    const base64Data = new Buffer.from(canvas.replace(/^data:image\/\w+;base64,/, ""), 'base64');
    const type = canvas.split(';')[0].split('/')[1];
    const currentDate = moment().format('YYYY/MM/DD');
    const uniqueId = uuidv4();

    let fileUrl = `${props.uploadPath}/uploads/${currentDate}/${uniqueId}.png`;

    if (keys?.bucketS3 && keys?.bucketS3?.path_default && keys?.bucketS3?.path_default != '') {
      fileUrl = `${keys?.bucketS3?.path_default}/${props.uploadPath}/uploads/${currentDate}/${uniqueId}.png`;
    } else {
      Toast.error('Erro ao fazer o upload do arquivo. É necessário informar o path_default nas configurações.');
      return;
    }

    fileUrl = fileUrl.replace('//', '/');

    const params = {
      Bucket: keys?.bucketS3?.bucket,
      Key: fileUrl,
      Body: base64Data,
      ContentEncoding: 'base64',
      ContentType: `image/${type}`
    }
    setCanvas(canvas);
    setCanvasVisibility(true);

    try {
      props.beforeUpload();
      const { Location } = await s3.upload(params).promise();
      props.onUpload(props.name, Location);
      Toast.success("Assinatura salva.");
    } catch (error) {
      Toast.error("Erro ao salvar assinatura.");
    }
  }, []);

  return (
    <>
      <div
        ref={containerRef} className={`signature-field ${isHighlighted ? 'highlight' : ''} border border-black d-flex align-items-center`}
        style={{ width: `${props.width || 500}px`, height: `${props.height || 250}px` }}
      >
        {!canvasVisibility && (
          <SignatureCanvas
            ref={padRef}
            canvasProps={{
              width: props.width || 500,
              height: props.height || 250,
            }}
          />
        )}
        <div className="ml-4">
          {(canvasVisibility &&
            <img
              src={canvas}
              alt="signature"
              style={{ width: `${props.width || 500}px`, height: `${props.height || 250}` }}
            />
          )}
        </div>
      </div>
      <div
        className="d-flex align-items-center justify-content-between mt-2"
        style={{ width: `${props.width || 500}px` }}
      >
        <button
          className="btn btn-sm btn-secondary"
          onClick={clearSignatureCanvas}
          disabled={props.readOnly}
        >
          Limpar
        </button>
        <button
          className="btn btn-sm btn-primary"
          onClick={handleGetCanvas}
          disabled={props.readOnly || canvasVisibility}
        >
          Salvar
        </button>
      </div>
      {props.error && (
        <span className="error invalid-feedback" style={{ display: "inline" }}>
          {props.error}
        </span>
      )}
    </>
  );
})
